import { Chip } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { SyncQueueStatus } from "@home-health-notify/models";
import { SYNC_QUEUE_STATUS_LABEL } from "./syncQueueConstants";

// Six visually distinct states drawn from theme tokens (amber, green, grey,
// red, dark-neutral, orange) — MUI's semantic slots only cover five, so the
// two amber/orange and grey/dark-neutral pairs are split across palette shades.
const chipStyle = (
  theme: Theme,
): Record<SyncQueueStatus, { backgroundColor: string; color: string }> => ({
  pending: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
  },
  added: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
  },
  skipped: {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.text.primary,
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
  rejected: {
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.common.white,
  },
  blocked_on_mapping: {
    backgroundColor: theme.palette.warning.dark,
    color: theme.palette.warning.contrastText,
  },
});

const SyncQueueStatusBadge = ({ status }: { status: SyncQueueStatus }) => (
  <Chip
    label={SYNC_QUEUE_STATUS_LABEL[status]}
    size="small"
    data-testid={`sync-queue-status-${status}`}
    sx={theme => chipStyle(theme)[status]}
  />
);

export default SyncQueueStatusBadge;
